(function () {
  if (sessionStorage.getItem("transcy_redirect_done")) return;

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    if (match) {
      try {
        return JSON.parse(decodeURIComponent(match[2]));
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  const transcyLocale = getCookie("transcy_cookie_locale");
  const currentPath = window.location.pathname;

  if (transcyLocale && transcyLocale.locale_redirect) {
    const redirectLocale = transcyLocale.locale_redirect;
    const pathLocaleMatch = currentPath.match(/^\/([a-z]{2})(\/|$)/);

    if (!pathLocaleMatch) {
      sessionStorage.setItem("transcy_redirect_done", "true");
      const search = window.location.search;
      const hash = window.location.hash;

      // "en"の場合はパスに言語コードを付けない
      const newPath =
        redirectLocale === "en"
          ? currentPath
          : "/" + redirectLocale + currentPath;

      window.location.href = newPath + search + hash;
    }
  }
})();